// extracted by mini-css-extract-plugin
export default {"section-container":"g1FAqg1iATxm6VXUOR5b","section-title":"K1kQMSeoQwuIFxCZBu1z","section-table-wrapper":"cIfNkVyBymm2lPzbSkxz"};